import React from "react";

const BookIframe = () => {
  return (
    <div style={{ height: "1000px" }}>
      <iframe
        src="https://calendly.com/phanthanhhuy1996/lesson?hide_gdpr_banner=1"
        width="100%"
        height="100%"
        frameborder="0"
      ></iframe>
    </div>
  );
};

export default BookIframe;